<template>
  <v-app>
    <v-content>
      <v-container class="fill-height" style="justify-content: center" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="6" md="6" lg="6" xl="6">
            <v-row align="center" justify="center">
              <v-card class="mx-auto" width="400">
                <v-row justify="center">
                  <v-img
                    align="center"
                    justify="center"
                    class="mt-12"
                    aspect-ratio="5"
                    :transition="false"
                    contain
                    :src="
                      require(`@/assets/${this.$store.getters.getLogo.path}/logo.png`)
                    "
                  />
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-row align="center" justify="center">
                      <v-card-text
                        style="word-break: normal; text-align: center"
                        class="mb-0 pb-0"
                        >{{ $t("general.register.welcomeTo") }}
                        {{ $store.getters.getTheme.title }}.</v-card-text
                      >
                      <v-card-text
                        class="mt-0 pt-0"
                        style="word-break: normal; text-align: center"
                      >
                        {{
                          $t("general.register.pleaseRegisterToGetStarted")
                        }}</v-card-text
                      >
                    </v-row>
                  </v-col>
                </v-row>
                <v-form
                  @keydown.native.enter="register"
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-row no-gutters>
                    <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                      <v-text-field
                        class="mx-6"
                        color="primary"
                        :rules="emailRule"
                        :label="$t('general.register.enterEmail')"
                        type="text"
                        v-model="input.email"
                        disabled
                        required
                      />
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                      <v-text-field
                        class="mx-6"
                        color="primary"
                        :label="$t('general.register.enterPassword')"
                        type="password"
                        :rules="passwordlRule"
                        v-model="input.password"
                        required
                      />
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                      <v-text-field
                        class="mx-6"
                        color="primary"
                        :label="$t('general.register.retypePassword')"
                        type="password"
                        :rules="passwordlRule"
                        v-model="input.confirmPassword"
                        required
                      />
                    </v-col>
                  </v-row>
                  <v-card-actions>
                    <v-col cols="12">
                      <v-btn
                        class="float-right"
                        @click="register"
                        :loading="loading"
                        color="primary"
                        dark
                        text
                        >{{ $t("general.register.register") }}</v-btn
                      >
                    </v-col>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
    <powered-by-sentinel :is-navbar="false" />
  </v-app>
</template>

<script>
import { AUTH_REGISTER } from "@/store/actions/auth.js";
import { USER_CRM_REQUEST } from "@/store/actions/user";
import cookie from "@/utils/cookie";
import snackbar from "@/utils/snackbar";
import api from "@/utils/api";
import { mapGetters } from "vuex";
import restrictions from "@/utils/restrictions";
import PoweredBySentinel from "@/components/banners/PoweredBySentinel.vue";

export default {
  components: { PoweredBySentinel },
  data() {
    return {
      emailRule: [],
      passwordlRule: [],
      valid: true,
      isDirty: false,
      errorText: "",
      loading: false,
      input: {
        email: "",
        password: "",
        confirmPassword: "",
      },
    };
  },
  created() {
    this.setInitialData();
    cookie.getCookie("user-token")
      ? this.handleAlreadyLoggedIn()
      : this.handleUsername();
  },
  computed: {
    ...mapGetters(["getMe", "getTheme"]),
  },
  methods: {
    navigate() {
      let isVisible = [];
      for (const property in this.getMe.menu_access) {
        isVisible.push(this.getMe.menu_access[property].visible);
      }
      if (!isVisible.some((element) => element)) {
        this.$router.pushAsync({
          name: "new-user",
        });
      } else {
        if (this.$route.query["next"]) {
          this.$router.pushAsync({
            path: this.$route.query["next"],
          });
        } else {
          const nextRoute = restrictions.nextBaseRoute(this.getMe);

          this.$router
            .pushAsync(nextRoute)
            .then((resp) => {
              this.loading = false;
            })
            .catch((e) => {});
        }
      }
    },
    setInitialData() {
      this.emailRule = [
        (v) => !!v || this.$t("general.register.eMailIsRequired"),
        (v) =>
          /.+@.+\..+/.test(v) || this.$t("general.register.eMailMustBeValid"),
      ];
      this.passwordlRule = [
        (v) => !!v || this.$t("general.register.passwordIsRequired"),
        (v) =>
          v.length >= 8 ||
          this.$t("general.register.passwordMustBeGraterThan8Characters"),
      ];
    },
    handleAlreadyLoggedIn() {
      cookie.deleteCookie("user-token");
      snackbar.success(
        this.$t(
          "utils.snackbar.success.youExistingSessionHasBeenExpiredYouCanNowRegisterANewAccount"
        )
      );
      setTimeout(() => {
        location.reload();
      }, 4000);
    },

    handleUsername() {
      //false parameter is here for disabling error handling
      api
        .getUsernameByUuid(this.$route.params.uuid, false)
        .then((resp) => {
          this.input.email = resp.data.username;
        })
        .catch((err) => {
          if (
            err.response.status === 400 &&
            err.response.data.error[0] === "USER_EXISTS"
          ) {
            this.$router.push({
              name: "login",
            });
            snackbar.error(
              this.$t("utils.snackbar.error.userAlreadyRegisteredPleaseLogin")
            );
          } else if (err.response.status === 404) {
            snackbar.error(
              this.$t(
                "utils.snackbar.error.registrationKeyDoesNotExistOrItHasExpired"
              )
            );
          } else {
            snackbar.error(err.response.data.error_message[0]);
          }
        });
    },

    register() {
      if (this.$refs.form.validate()) {
        if (this.input.password === this.input.confirmPassword) {
          const { email, password, confirmPassword } = this.input;
          const language =
            window.navigator.userLanguage || window.navigator.language;
          this.loading = true;
          this.$store
            .dispatch(AUTH_REGISTER, {
              email,
              password,
              confirmPassword,
              uuid: this.$route.params.uuid,
              preferred_language: language,
            })
            .then(() => {
              this.loading = false;
              //This kind of state is handled by this.$store.dispatch(USER_CRM_REQUEST), user gets the TOS screen or 6-step
              // this.$router.pushAsync({ name: "termsOfService" }).then(() => {
              //   this.$store.dispatch(USER_CRM_REQUEST);
              // });
              // this.navigate();
            })
            .catch((err) => {
              this.isDirty = true;
            });
        } else {
          snackbar.error(
            this.$t("utils.snackbar.error.thosePasswordsDoNotMatchTryAgain")
          );
        }
      }
    },
  },
};
</script>
<style scoped></style>
